import { inject } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  Router,
  CanActivateFn,
  UrlTree,
} from '@angular/router';
import { Observable, of } from 'rxjs';
import { map, switchMap } from 'rxjs/operators';
import { AuthService } from './services/auth.service';
import { TokenService } from './services/token.service';
import { environment } from 'src/environments/environment';

export const AuthGuard: CanActivateFn = (
  route: ActivatedRouteSnapshot,
  state: RouterStateSnapshot
): Observable<boolean | UrlTree> => {
  const authService = inject(AuthService);
  const router = inject(Router);
  const tokenService = inject(TokenService);

  return authService.getToken().pipe(
    switchMap((token) => {
      if (!token) {
        location.href = `${environment.authUrl}/?url=${encodeURIComponent(location.host)}${encodeURIComponent(location.pathname)}`;
        return of(false);
      }

      return tokenService.decodeToken(token!).pipe(
        map((decodedToken) => {
          const hasAccess = AuthService.canTokenActivate(
            decodedToken,
            route.data['roles']
          );

          return hasAccess ? true : router.createUrlTree(['/accessDenied']);
        })
      );
    }),
  );
};
